import React from 'react'
import PropTypes from 'prop-types'
import SignaturePadComponent from 'signature_pad'
import './index.css'

class SignaturePad extends React.Component {
  componentDidMount() {
    this._signaturePad = new SignaturePadComponent(this._canvas, {
      backgroundColor: 'rgb(255, 255, 255)',
    })

    window.addEventListener('resize', this.resizeCanvas)
    this.resizeCanvas()

    if (this.props.signature) {
      this._signaturePad.fromDataURL(this.props.signature)
    }

    if (this.props.disabled) {
      this._signaturePad.off()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCanvas)
    this._signaturePad.off()
  }

  clear = () => {
    return this._signaturePad.clear()
  }

  isEmpty = () => {
    return this._signaturePad.isEmpty()
  }

  toDataURL = (contentType = null) => {
    return this._signaturePad.toDataURL(contentType)
  }

  disable = () => {
    return this._signaturePad.off()
  }

  // Adjust canvas coordinate space taking into account pixel ratio,
  // to make it look crisp on mobile devices.
  // This also causes canvas to be cleared.
  resizeCanvas = () => {
    const canvas = this._canvas

    // When zoomed out to less than 100%, for some very strange reason,
    // some browsers report devicePixelRatio as less than 1
    // and only part of the canvas is cleared then.
    const ratio =  Math.max(window.devicePixelRatio || 1, 1)

    // This part causes the canvas to be cleared
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext('2d').scale(ratio, ratio)

    // This library does not listen for canvas changes, so after the canvas is automatically
    // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
    // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
    // that the state of this library is consistent with visual state of the canvas, you
    // have to clear it manually.
    this.clear()
  }

  render() {
    return (
      <canvas
        ref={(ref) => this._canvas = ref}
        className="signature-pad-canvas"
        style={this.props.style}
      />
    )
  }
}

SignaturePad.propTypes = {
  style: PropTypes.object,
  signature: PropTypes.string,
  disabled: PropTypes.bool,
}

SignaturePad.defaultProps = {
  style: {},
}

export default SignaturePad
